import React, { memo } from "react";
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";

import { View, Text } from "../../../Base";
import { LoadProgressIcon } from "../../../icons";
import RouteStatus from "../../../../enums/RouteStatus";
import palette from "../../../styles/palette";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    maxWidth: "95px",
    "-webkit-touch-callout": "none",
    "-webkit-user-select": "none",
    "-khtml-user-select": "none",
    "-moz-user-select": "none",
    "-ms-user-select": "none",
    "user-select": "none",
  },
  iconStatus: {
    width: "1rem",
    height: "1rem",
    marginLeft: "0.125rem",

    "& svg": {
      width: "1rem",
      height: "1rem",
    },
  },
  iconStatusRed: {
    "& svg": {
      fill: "red",
    },
  },
  bold: {
    fontWeight: "bold",
  },
  text: {
    fontSize: "0.75rem",
    lineHeight: "1rem",
    color: "white",
    flexDirection: "row",
    display: "flex",
  },
  percentageText: {
    marginLeft: "0.313rem",
    color: palette.typography.white.high,
  },
}));

const Loading = ({
  routeStatus,
  routeStatusDescription,
  lowLoadRate,
  loadingPercentage,
}) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <Text
        className={clsx(styles.text, styles.bold)}
        data-testid="loading-description"
      >
        {routeStatusDescription}
      </Text>
      <Text
        className={clsx(styles.text, styles.percentageText)}
        data-testid="loading-percentage"
      >
        {parseInt(routeStatus) === RouteStatus.LOADING &&
          loadingPercentage + "%"}
      </Text>
      <View
        className={clsx(styles.iconStatus, lowLoadRate && styles.iconStatusRed)}
      >
        {parseInt(routeStatus) === RouteStatus.LOADING && <LoadProgressIcon />}
      </View>
    </View>
  );
};

export default memo(Loading);
